import React from 'react';

/*
Sirina columne dobija osnovnu sirinu koja se zada sa props.w
A ukoliko nema mesta bice uza.
Ukoliko je unutra siri element dobice sirinu tog najsireg elementa (min-width: min-content)


*/

const ColumnWidth = (props) => {
  /*
  let cl = 'w480';
  if (props.w > 0) {
    cl = 'w' + props.w;
  } else if (typeof props.w === 'string' && props.w !== '') {
    cl = props.w;
  }
  */

  let cl = '';
  if (typeof props.extraClass === 'string') {
    cl = ' ' + props.extraClass;
  }

  let style = {};
  if (props.w > 0 || props.w === 0) {
    style = {
      flexBasis: props.w, // OLD
      width: props.w, // NEW v2
    };
  }

  /*
  v1 DELETED
  <div className={"widget-column-width" + cl}>
    <div className={"target-col"} style={style}>
      {props.children}
    </div>
    <div className="flex-col"></div>
  </div>
  */
  return (
    <>
      <div className={"widget-column-width-v2" + cl}>
        <div className={"target-col"} style={style}>
          {props.children}
        </div>
      </div>
    </>
  );
};

export default ColumnWidth;